import { ReactNode } from 'react';

import { TagDisplay, TagItem } from '../tag-display/TagDisplay';

export interface TagDisplayGroupProps {
  type: 'anychat' | 'anytag';
  tags: TagItem[];
  aside?: ReactNode;
  synced?: boolean;
  showSyncStatus?: boolean;
  onRemove?: (id?: string) => void;
}

export interface TagDisplayGroupsProps {
  groups?: TagDisplayGroupProps[];
  disabled?: boolean;
}

const getTagDisplayProps = ({
  type,
  tags,
  aside,
  synced,
  showSyncStatus,
  onRemove,
}: TagDisplayGroupProps) =>
  ({
    anytag: {
      type: 'anytag' as const,
      tags,
      aside,
      showSyncStatus,
      synced,
      onRemove,
    },
    anychat: {
      type: 'anychat' as const,
      tags,
      aside,
      showSyncStatus: false,
      onRemove,
    },
  })[type];

export const TagDisplayGroup = ({ groups = [], disabled }: TagDisplayGroupsProps) => (
  <div className="flex flex-col gap-y-3">
    {groups.map((group) => (
      <TagDisplay key={group.type} {...getTagDisplayProps(group)} disabled={disabled} />
    ))}
  </div>
);
